// English strings for P7-A (BILLING-01/02/03/04/06/07/10, PARTNER-01) (D-013: English only). Owned by that worker;
// spread into `en` as `en.wallet`, so keys read `t("wallet.…")`. Copy rules: DESIGN_SYSTEM §9.6.
export const walletStrings = {
  notify: {
    low: "Your Adyvance credit is low",
    renewalDue:
      "Your paid plan ends in {days} days. Renew it, or your shop moves to the Free plan.",
    renewalToday: "Your paid plan ends today. Renew it now, or your shop moves to the Free plan.",
    trialEnding: "Your trial ends in {days} days",
    trialToday: "Your trial ends today",
  },
  gateway: {
    title: "Online payment for Adyvance billing is not set up yet",
    body: "Nothing can be charged until Adyvance sets up its payment account. Nothing was charged.",
    step: "Adyvance sets up its billing payment account",
  },
  credit: {
    title: "Adyvance Wallet",
    lead: "One prepaid balance for plans, SMS, root AI, themes, ads and imports.",
    balance: "Balance",
    reserved: "Held for sends in progress",
    available: "Available to spend",
    low: "Low credit",
    lowHelp: "Available credit is below {threshold}. Messages stop when it runs out.",
    viewStatement: "Open the wallet",
    topUp: "Add credit",
    topUpUnavailable: "Adding credit online is not available yet.",
  },
  statement: {
    title: "Credit statement",
    lead: "Every change to {org}'s credit, newest first.",
    caption: "Credit statement",
    when: "Date",
    what: "Entry",
    amount: "Amount",
    after: "Available after",
    empty: "No credit activity yet",
    emptyBody: "Credit added or spent shows here.",
    more: "Show older entries",
    back: "Plan and billing",
    kinds: {
      topup: "Credit added",
      debit: "Spent",
      reserve: "Held for a send",
      release: "Hold released",
      refund: "Refund",
      mission: "Reward",
      unknown: "Other",
    },
    refs: {
      outbound_message: "Message",
      campaign: "Campaign",
      topup: "Top-up",
      adjustment: "Adjustment by Adyvance",
      unknown: "Other",
    },
    swept: "Released automatically after 24 hours",
    uncollected: "{amount} could not be collected",
  },
  trial: {
    title: "Trial",
    noPlan: "No plan offers a trial right now. Your business stays on its current plan.",
    used: "This business has already used its trial.",
    subscribed: "This business already has a paid plan.",
    offer: "Try {plan} free for {days} days. No card is needed and nothing is charged.",
    start: "Start the trial",
    starting: "Starting the trial…",
    ownerOnly: "Only the business Owner can start a trial.",
    active: "Trial of {plan} until {when}.",
    ended: "Your trial of {plan} ended on {when}.",
    noConvert:
      "When the trial ends your business returns to its current plan. It never turns into a paid plan.",
    started: "Trial started",
  },
  invoices: {
    title: "Invoices",
    caption: "Adyvance invoices",
    number: "Invoice",
    date: "Date",
    amount: "Amount",
    status: "Status",
    empty: "No invoices yet",
    emptyBody: "Every business is on the Free plan, so there is nothing to invoice.",
    states: {
      draft: "Draft",
      open: "Due",
      paid: "Paid",
      void: "Void",
      refunded: "Refunded",
      unknown: "Unknown",
    },
  },
  addons: {
    title: "Add-ons",
    lead: "Add-ons raise a limit of your plan, for example one more location.",
    increment: "+{n} {quota}",
    priceNotSet: "Price not set yet",
    active: "Included add-ons",
    none: "No add-ons yet.",
    buy: "Buy",
    offers: {
      extra_location: "Extra location",
      extra_pos_register: "Extra POS register",
      unknown: "Add-on",
    },
  },
  refunds: {
    title: "Refunds and credits",
    none: "Self-serve refunds are not offered. Contact Adyvance support about a charge.",
    window: "You can ask for a refund within {days} days of a payment.",
  },
  checkout: {
    title: "Paid plans",
    body: "Wallet money is non-refundable. Plans renew from the wallet only when you turn on auto-renew.",
  },
  referral: {
    label: "Referral code (optional)",
    help: "If an agency or partner sent you, enter their code.",
    invalid: "Use 3 to 32 letters, numbers or hyphens.",
  },
  graceEnds: "Grace period ends {when}. After that your business returns to the Free plan.",
  periodEnds: "Paid until {when}.",
} as const;
